import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const s = a((r, e) => /* @__PURE__ */ o.jsx(
  i,
  {
    ref: e,
    ...r,
    image: (l) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...l,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M8 1a1 1 0 0 1 .866.5l6.929 12a1 1 0 0 1-.866 1.5H1.072a1 1 0 0 1-.866-1.5l6.928-12A1 1 0 0 1 8 1M7 6h2v4H7zm0 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
s.displayName = "ErrorIcon";
export {
  s as ErrorIcon,
  s as default
};
//# sourceMappingURL=index.js.map
